import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import { columnRenderArrayData } from "utils/tableUtils";
import Crunch42CredentialsForm from "./Crunch42CredentialsForm";
import Crunch42MappingForm from "./Crunch42MappingForm";

export default function Crunch42ConfigListing(props) {
  const columns = useMemo(() => [
    {
      title: "Collection",
      dataIndex: "collectionName",
      width: 200,
    },
    {
      title: "API Name",
      dataIndex: "apiNames",
      //apiName usually contains comma in their name, checking if the apiName is single or multiple
      render: (apiName) => apiName ? apiName.includes(",") ? columnRenderArrayData(apiName) : apiName : 'ALL',
      width: 200,
    }
  ], []);

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      extraColumns={columns}
      MappingForm={Crunch42MappingForm}
      CredentialsForm={Crunch42CredentialsForm}
    />
  );
}
